const NavLogoIcon = () => {
  return (
    <img
      src={`${import.meta.env.VITE_ASSET_URL || '/images'}/blogging-dev-icon.svg`}
      alt="blogging.dev Logo"
      className="h-5 w-5 dark:brightness-0 dark:invert"
    />
  )
}

export default NavLogoIcon
